import {Component, Injector, EventEmitter, Output} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { ToasterService } from '../../services/toaster.service';

@Component({
    template: `
    <div class="user-popover-outline">
        <div class="user-popover">
            <!--  ng-controller="CreateBattleController" -->
            <div class="bar-header">
                <h1 class="title ly_pop_title">신고하기</h1>
                <a class="ly_pop_close" (click)="closePopover()"><mat-icon class="mat-icon-30 btn_close" svgIcon="xi-close"></mat-icon></a>
            </div>

            <form name="popupForm" class="popupForm">
                <div class="pop-body">
                    <div class="report_select">
                        <mat-radio-group [(ngModel)]="claim.nw_type" name="nw_type">
                            <mat-radio-button value="욕설/비방" class="mat-radio">욕설&#47;비방</mat-radio-button>
                            <mat-radio-button value="음란/저속표현" class="mat-radio">음란&#47;저속표현</mat-radio-button>
                            <mat-radio-button value="홍보/상업성" class="mat-radio">홍보&#47;상업성</mat-radio-button>
                            <mat-radio-button value="기타" class="mat-radio">기타</mat-radio-button>
                        </mat-radio-group>
                        <mat-form-field style="width: 100%;">
                            <textarea matInput [(ngModel)]="claim.nw_reason" name="nw_reason" placeholder="신고내용을 적어주세요.(200자이네)" rows="5" mat-maxlength="200" required></textarea>
                        </mat-form-field>
                    </div>
                </div><!-- .pop-body -->
                <div class="pop-footer">
                    <button mat-button class="full btn_create" (click)="claimExcute()"><span style="color: #fff;">확인</span></button>
                </div><!-- .pop-footer -->
            </form>
        </div><!-- .popover -->
    </div>`,
    styleUrls: ['style.scss']
})

export class LayerPopClaimComponent {
    @Output() popclosed = new EventEmitter();
    inputObj: any;

    claim: any = {nw_type: '', nw_reason: ''};
    constructor(private injector: Injector, private http: HttpService, protected toasterService: ToasterService) { // private :
        this.inputObj = this.injector.get('paramObj');
    }

    claimExcute() {
        // 게시판인 경우 : let param_obj = {w_id: $scope.feed.wr_id, group: 'board', board: $scope.categoryId, nw_type: $scope.claim.nw_type, nw_reason: $scope.claim.nw_reason};
        const param_obj = this.claim;
        param_obj.w_id = this.inputObj.w_id;
        param_obj.board = this.inputObj.board;
        param_obj.group = this.inputObj.group;

        this.http.post({url: 'claim', params: param_obj}).then((obj) => {
            if (obj.result === true) {
                this.toasterService.showToaster('info', '신고가 정상적으로 처리 되었습니다.');
            } else {
                this.toasterService.showToaster('error', obj.message);
            }
            this.closePopover();

        });

    }

    closePopover() {
        this.popclosed.emit();
    }
}
